<app-card-actions heading="Notifications" (close)="close()">
 
</app-card-actions>
<div class="clear-row">
  <button [appConfirm]="'Do you really want to clear all your notifications?'" 
          color="accent" 
          mat-raised-button 
          (confirm)="clearAll()" 
          class="clear-all">
    Clear All
  </button>
</div>
<div class="notifications" *ngIf="notifications.length > 0">
  <div *ngFor="let item of notifications;">
    <ng-container [ngSwitch]="item.type">
      <div class="notification-wrapper" *ngSwitchCase="'assigned'">
        <div class="notification" (click)="navigate(item)">
          <div class="header">
            <div class="card-context">
              <div class="board">
                <img *ngIf="item.boardIcon" [src]="item.boardIcon" alt="{{item.board}}" class="board-icon">
                <span class="board-name">{{item.board}}</span>
              </div>
              <div class="card-name">{{item.card}}</div>
            </div>
            <div class="actions">
              <div class="delete" (click)="delete(item); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="line">This card has been assigned to you <span class="timestamp">({{item.createdAt | chatTimeAgo}})</span></div>
            <div class="line">Client: <b>{{getClientName(item.client)}}</b></div>
            <div class="line">Card: <b>{{item.card}}</b></div>
          </div>
        </div>
      </div>

      <div class="notification-wrapper" *ngSwitchCase="'yours'">
        <div class="notification" (click)="navigate(item)" [class.done]="item.status === 'Done/Completed'">
          <div class="header">
            <div class="card-context">
              <div class="board">
                <img *ngIf="item.boardIcon" [src]="item.boardIcon" alt="{{item.board}}" class="board-icon">
                <span class="board-name">{{item.board}}</span>
              </div>
              <div class="card-name">{{item.card}}</div>
            </div>
            <div class="actions">
              <div class="delete" (click)="delete(item); $event.stopPropagation()">
                <mat-icon>delete</mat-icon>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="line">A card you reported on got changed <span class="timestamp">({{item.createdAt | chatTimeAgo}})</span></div>
            <div class="line">From: <b>{{item.statusPrevious}}</b></div>
            <div class="line">To: <b>{{item.status}}</b></div>     
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div class="empty-state" *ngIf="notifications.length === 0">
  <mat-icon>notifications_off</mat-icon>
  <p>No notifications available</p>
</div>